// extracted by css-extract-rspack-plugin
export default {"root":"f12gYi","count-and-variation-tag":"_S2Iaa","countAndVariationTag":"_S2Iaa"};